import { render } from "./PaymentConfirm.vue?vue&type=template&id=57dda626&scoped=true"
import script from "./PaymentConfirm.vue?vue&type=script&lang=js"
export * from "./PaymentConfirm.vue?vue&type=script&lang=js"

import "./PaymentConfirm.vue?vue&type=style&index=0&id=57dda626&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.24_vue@3.4.24_webpack@5.91.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57dda626"]])

export default __exports__